// extracted by mini-css-extract-plugin
export var imageSection = "bQ_b1";
export var loanCard = "bQ_f4";
export var textSection = "bQ_b2";